var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"aria-labelledby":_vm.id}},[_c('h2',{attrs:{"id":_vm.id}},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('a',{staticClass:"anchor-link",attrs:{"aria-hidden":"true","href":_vm.href}},[_vm._v(" # ")])]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }